<template>
  <div class="ui-pop" v-show="info.show">
    <div class="ui-mask" @click="info.show = false"></div>
    <div class="ui-comfirm ui-modal">
      <p class="title">{{info.title}}</p>
      <div class="content">
        <p class="topic">{{info.topic}}</p>
        <p class="desc">{{info.desc}}</p>
        <div class="btns">
          <a class="ui-btn gray" @click="cancel()">{{info.cancel}}</a>
          <a class="ui-btn" @click="comfirm()">{{info.comfirm}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['info'],
  methods: {
    cancel(){
      this.$emit('cancel',false)
    },
    comfirm(){
      this.$emit('submit')
    }
  }
}
</script>
<style lang="scss" scoped>
.ui-pop{
  .desc{
    margin: 0 20px;
  }
}
</style>